import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Col, Select } from 'antd';
@inject('streamManagementStore')
@observer
class SearchForm extends Component {
  state = {
  }
  formRef = React.createRef();
  componentDidMount() {
    const { streamManagementStore } = this.props
    streamManagementStore.onSearchStreamAction({ "dagNames": [] })
  }
  handleSearch=()=>{
    const { streamManagementStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      streamManagementStore.onSearchStreamAction({dagNames: fieldsValue.dagNames ===''||fieldsValue.dagNames ===null||fieldsValue.dagNames ===undefined ?[]:[fieldsValue.dagNames]})
    }).catch(err => {
    })
  }
  handleRestart=()=>{
    const { streamManagementStore } = this.props
    streamManagementStore.onRestartStreamAction('STRUCTURED_STREAMING_INGESTION')
  }
  render() {
    return (
      <>
        <Row>
            <Col span={16}>
              <Form ref={this.formRef} labelCol={{ span: 8 }} initialValues={{index: 0,name: '', key: ''}}>
                <Row wrap={true} gutter={[10,10]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} span={12}>
                    <Form.Item name='dagNames' label='Stream Name' labelCol={{span:8}} wrapperCol={{span:16}} rules={[{ message: 'Please select Customer.'}]}>
                      <Select placeholder="Please select ..." onChange={this.onChange} showSearch allowClear >
                        <Select.Option key='ROW_DATA_ASN' value='ROW_DATA_ASN'>ROW_DATA_ASN</Select.Option>
                        <Select.Option key='ROW_DATA_BIL_INV' value='ROW_DATA_BIL_INV'>ROW_DATA_BIL_INV</Select.Option>
                        <Select.Option key='ROW_DATA_OTHER' value='ROW_DATA_OTHER'>ROW_DATA_OTHER</Select.Option>
                        <Select.Option key='ROW_DATA_PO_CRV' value='ROW_DATA_PO_CRV'>ROW_DATA_PO_CRV</Select.Option>
                        <Select.Option key='ROW_DATA_PO_NORMAL' value='ROW_DATA_PO_NORMAL'>ROW_DATA_PO_NORMAL</Select.Option>
                        <Select.Option key='STRUCTURED_STREAMING_INGESTION' value='STRUCTURED_STREAMING_INGESTION'>STRUCTURED_STREAMING_INGESTION</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col span={8} style={{textAlign: 'right'}}>
              <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
              <Button style={{ width: 'auto'}} onClick={this.handleRestart} type='primary'>Total Restart</Button>
            </Col>
        </Row>
      </>
    );
  }
}

export default SearchForm;
